export const code = {
    isDevelopmentEnv: () => process.env.NODE_ENV === "development",
    isTestEnv: () => process.env.NODE_ENV === "test",
    isStgEnv: () => process.env.NODE_ENV === "staging",
    isSecEnv: () => process.env.NODE_ENV === "security",
    isProductionEnv: () => process.env.NODE_ENV === "production",
    getCookie: (name: string): string | null => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(";").shift() ?? null;
        return null;
    },
    setCookie: (name: string, value: string, days = 7): void => {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value};${expires};path=/`;
    },
    localNumbers: (value: unknown): string | null => {
        if (typeof value !== "number") return null;
        return value.toLocaleString("fa-IR");
    },
};
